import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'

import { transposeArrayType } from '../../../../utils/transpose-array-type'
import { useTypedSelector } from 'src/State/RootReducer'
import { ChartView } from '../../../../types/chart-types'
import { usePortalQuery } from 'src/Libs/api'

export interface WallboxHistoryDatumDto {
  time: number
  energyAll: number
  energySolar: number
  energyDischarged: number
}

type RawWallboxHistoryDataStepsParams = {
  /** UTC unix epoch milleseconds */
  from: number
  /** UTC unix epoch milleseconds */
  to: number
  view: ChartView

  /** UTC unix epoch milleseconds of the date the installation was created */
  firstOnlineDate?: number
  includeFirst?: boolean
  includeLast?: boolean
}

type UseWallboxHistoryDataSteps = {
  data: WallboxHistoryDatumDto[]
  isLoading: boolean
  isError: boolean
}

export function useWallboxHistoryDataSteps(
  serialNumber: string | null,
  wallboxId: string | null,
  params: RawWallboxHistoryDataStepsParams,
  enabled = true
): UseWallboxHistoryDataSteps {
  const authFetch = useAuthFetchWithResult()
  const refresh = useTypedSelector(state => state.apiView.refresh)

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['wallboxHistorySteps', serialNumber, wallboxId, params, refresh],
    queryFn: async () => {
      const res = await authFetch<ArrayType<WallboxHistoryDatumDto>>({
        path: `wallboxes/${serialNumber}/${wallboxId}/historydata/steps`,
        payload: {
          ...params,
          isRawData: true,
          calculateDiff: true,
        },
      })

      return transposeArrayType(res)
    },
    enabled: Boolean(serialNumber && wallboxId) && enabled,
  })

  return {
    data: data || [],
    isLoading,
    isError,
  }
}
